import Marquee from "react-fast-marquee";

/**
 * EditorialMarquee — slow horizontal ribbon. Divider dots between phrases.
 * Wrapped with an edge fade mask for a polished editorial feel.
 */
export default function EditorialMarquee({
  phrases = [
    "Hideaway Cattle Company",
    "Stevensville, Montana",
    "Registered Angus & Charolais Seedstock",
    "Bitterroot Valley",
  ],
  speed = 28,
  className = "",
  variant = "light",
  testId,
}) {
  const isDark = variant === "dark";
  return (
    <div
      className={`relative w-full py-8 md:py-12 marquee-mask ${
        isDark ? "bg-obsidian text-bone" : "bg-bone text-ink"
      } ${className}`}
      data-testid={testId}
    >
      <Marquee gradient={false} speed={speed} pauseOnHover={false}>
        {phrases.map((p, i) => (
          <span
            key={i}
            className="font-serif italic text-4xl md:text-5xl lg:text-6xl font-light px-10 whitespace-nowrap flex items-center gap-10"
          >
            <span>{p}</span>
            <span
              aria-hidden
              className={`inline-block h-1.5 w-1.5 rounded-full ${
                isDark ? "bg-terracotta" : "bg-terracotta"
              }`}
            />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
